import { render } from "./activeryDetail.vue?vue&type=template&id=321e5da4&scoped=true"
import script from "./activeryDetail.vue?vue&type=script&lang=js"
export * from "./activeryDetail.vue?vue&type=script&lang=js"

import "./activeryDetail.vue?vue&type=style&index=0&id=321e5da4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321e5da4"]])

export default __exports__